import styled, { keyframes, css } from 'styled-components';

interface StatuProps {
  status: string;
}

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 6;

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px;
  transition: all 0.5s ease-out;

  h1 {
    font-weight: 500;
  }
  h2 {
    margin-left: 10px;
    color: #455a64;
  }

  @media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  padding: 10px 0;
  width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--azul-razio);
    font-weight: 500;

    svg {
      font-size: 20px;
      margin-right: 5px;
    }
  }
`;

export const OrderContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 5px 10px 50px 10px;
  margin-top: 45px;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;

  hr {
    background-color: #cfd8dc;
    border: none;
    width: 100%;
    height: 1px;
    margin: 10px 0 10px 0;
  }

  @media (max-width: 880px) {
    margin-top: 35px;
  }
`;

export const Cliente = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Order = styled.div<StatuProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .id-status {
    font-weight: 500;
  }

  span {
    color: #333;
  }

  ${props =>
    props.status === 'CANCELADO'
      ? css`
          span.status {
            color: #b71c1c;
						font-weight: 600;
          }
        `
			: props.status === 'CONCLUÍDO' || props.status === 'CONFIRMADA' || props.status === 'FINALIZADA'
      	? css`
          span.status {
            color: #1b5e20;
						font-weight: 600;
          }
        `
			: props.status === 'COM ENTREGADOR' || props.status === 'EM PREPARO'
      ? css`
          span.status {
            color: #1a83ff;
						font-weight: 600;
          }
        `
      : css`
          span.status {
            color: #ff6f00;
						font-weight: 600;
          }
        `}
`;

export const Mesa = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Items = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 5px;
  list-style: none;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  hr {
    background-color: #cfd8dc;
    border: none;
    width: 100%;
    height: 1px;
    margin: 10px 0 10px 0;
  }

  .qtd-name {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 13px;
      font-weight: 500;
      word-wrap: break-word;
      text-transform: uppercase;
    }
  }

  .qtd-complemento {
    span {
      font-size: 12px;
      font-weight: 500;
      color: #546e7a;
      word-wrap: break-word;
      text-transform: uppercase;
      padding: 0 10px;
    }
  }

  @media (max-width: 600px) {
    .qtd-name {
      span {
        font-size: 11px;
      }
    }

    .qtd-complemento {
      span {
        font-size: 11px;
      }
    }
  }
`;

export const Pagamento = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

	.pag-item {
		display: flex;
		flex-direction: column;
		padding: 5px 0;

		> h3 {
			font-size: 14px;
			color: #455a64;
			margin-left: 10px;
		}

		.pag-icon-name {
			display: flex;
			align-items: center;
			margin: 5px 0 0 10px;

			.pag-icon {
				display: flex;
				align-items: center;

				svg {
					margin-right: 10px;
				}

				img {
					margin-right: 10px;
					width: 25px;
					height: 20px;
				}
			}

			.pag-name-troco {
				display: flex;
				flex-direction: column;

				> h3 {
					font-size: 14px;
					margin-bottom: 0px;
				}

				> span {
					font-size: 13px;
					font-weight: 500;
				}
			}

			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 5px;
				width: 40px;
				height: 40px;
				background-color: #cfd8dc;
				border-radius: 10px;
				margin-right: 10px;

				svg {
					margin-right: 0;
				}
			}
		}
	}
`;

export const Cupom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const HorarioAgendado = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const EnderecoEntrega = styled.div`
  display: flex;
  flex-direction: column;

  .end-entrega {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-left: 10px;

    .icon-end {
      display: flex;
      align-items: center;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      width: 50px;
      height: 50px;
      background-color: #cfd8dc;
      border-radius: 10px;
      margin-right: 10px;
    }

    .end {
      .sem-endereco {
        color: #c53030;
        font-weight: 600;
      }
      > h1 {
        font-size: 16px;
        color: #455a64;
      }

      > h2 {
        font-size: 15px;
        color: #455a64;
        margin-left: 0;
      }
    }

    .buttons {
      button {
        border: none;
        background-color: #fff;
        font-size: 16px;
        font-weight: 600;
        color: #2196f3;
        margin-bottom: 10px;
      }
    }
  }

  @media (max-width: 600px) {
    margin: 10px 20px 30px 0;

    > h2 {
      font-size: 15px;
    }

    .end-entrega {
      .icon {
        padding: 5px;
        width: 45px;
        height: 45px;
      }

      .end {
        > h1 {
          font-size: 13px;
        }

        > h2 {
          font-size: 12px;
        }
      }

      .buttons {
        button {
          font-size: 14px;
        }
      }
    }
  }
`;

export const Total = styled.div`
  .content {
    margin-left: 10px;

    div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 14px;
        font-weight: 500;
      }
    }

    .sub-total {
      span {
        color: #455a64;
      }
    }

    .taxa-entrega {
      span {
        color: #455a64;
      }
    }

    .cupom {
      span {
        color: #2196f3;
      }
    }

    .total {
      span {
        font-weight: 600;
        color: #333;
      }
    }

    .troco-para {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 14px;
        font-weight: 500;
        color: #455a64;
      }
    }
  }

  @media (max-width: 880px) {
    margin-bottom: 110px;
  }
  @media (max-width: 600px) {
    .content {
      .sub-total {
        span {
          font-size: 12px;
        }
      }

      .taxa-entrega {
        span {
          font-size: 12px;
        }
      }

      .total {
        span {
          font-size: 12px;
        }
      }

      .troco-para {
        span {
          font-size: 12px;
        }
      }
    }
  }
`;
